export default __webpack_public_path__ + "static/media/BrixSansLight.36b8392b.woff2";